export default __webpack_public_path__ + "static/media/reports_sel.7a406b99.svg";